/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WsConversationReadStatus
 */
export interface WsConversationReadStatus {
    /**
     * Type of the message
     * @type {string}
     * @memberof WsConversationReadStatus
     */
    type: string | null;
    /**
     * The id of the conversation.
     * @type {string}
     * @memberof WsConversationReadStatus
     */
    conversationId: string;
    /**
     * Last message sequence seen by any of the user participants
     * @type {number}
     * @memberof WsConversationReadStatus
     */
    lastMessageSequenceSeen: number;
    /**
     * The minimum of unread messages from all user participants.
     * @type {number}
     * @memberof WsConversationReadStatus
     */
    unreadMessagesCount?: number | null;
}

/**
 * Check if a given object implements the WsConversationReadStatus interface.
 */
export function instanceOfWsConversationReadStatus(value: object): value is WsConversationReadStatus {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('lastMessageSequenceSeen' in value) || value['lastMessageSequenceSeen'] === undefined) return false;
    return true;
}

export function WsConversationReadStatusFromJSON(json: any): WsConversationReadStatus {
    return WsConversationReadStatusFromJSONTyped(json, false);
}

export function WsConversationReadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): WsConversationReadStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'conversationId': json['conversation_id'],
        'lastMessageSequenceSeen': json['last_message_sequence_seen'],
        'unreadMessagesCount': json['unread_messages_count'] == null ? undefined : json['unread_messages_count'],
    };
}

export function WsConversationReadStatusToJSON(json: any): WsConversationReadStatus {
    return WsConversationReadStatusToJSONTyped(json, false);
}

export function WsConversationReadStatusToJSONTyped(value?: WsConversationReadStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'conversation_id': value['conversationId'],
        'last_message_sequence_seen': value['lastMessageSequenceSeen'],
        'unread_messages_count': value['unreadMessagesCount'],
    };
}

